import { jsx as _jsx } from "react/jsx-runtime";
import { classNameMerge } from '@/lib/utils';
export default function ContentWrapper(_a) {
    var children = _a.children, className = _a.className;
    return _jsx("div", { className: classNameMerge("w-full flex flex-col items-center", className), children: children });
}
